/* LGB shopping-clarity layer (17 Oct 2026). See snippets/lgb-cx.liquid for what this does.
   Never writes lgb_project_v1 (My Project's own data). No prices are calculated here:
   every price, delivery, base and guarantee line comes from the theme's own snippets. */
(function () {
  'use strict';
  var C = window.LGBCX || {};
  var WA = 'https://wa.me/441543398778';
  var K_CMP = 'lgb_compare_v1', K_REC = 'lgb_recent_v1', K_EXT = 'lgb_project_extra_v1', K_PRJ = 'lgb_project_v1';
  var MAX_CMP = 4, MAX_REC = 8;

  /* ---------- helpers ---------- */
  function esc(x) { return String(x == null ? '' : x).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function txt(html) { var d = document.createElement('div'); d.innerHTML = html || ''; return (d.textContent || '').trim(); }
  function allowed() {
    /* Respect a visitor who has said no to "preferences" storage in the cookie banner. */
    try { var cp = window.Shopify && Shopify.customerPrivacy; if (cp && cp.currentVisitorConsent) { var c = cp.currentVisitorConsent(); if (c && c.preferences === 'no') return false; } } catch (e) {}
    return true;
  }
  function get(k, d) { try { var v = JSON.parse(localStorage.getItem(k)); return v == null ? d : v; } catch (e) { return d; } }
  function set(k, v) { if (!allowed()) return false; try { localStorage.setItem(k, JSON.stringify(v)); return true; } catch (e) { return false; } }
  function del(k) { try { localStorage.removeItem(k); } catch (e) {} }
  function track(a) { try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('lgb_app_click', { action: a, href: location.href }); } catch (e) {} }
  function sameSite(u) { return typeof u === 'string' && /^\/(products|collections|pages)\//.test(u) && u.indexOf('//') !== 0; }
  function okImg(u) { return typeof u === 'string' && /^(https:)?\/\/(cdn\.shopify\.com|[^/]*lichfieldgardenbuildings\.com)\//.test(u); }
  function previewQs() { try { if (Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main') return '&preview_theme_id=' + Shopify.theme.id; } catch (e) {} return ''; }
  function main() { return document.querySelector('main') || document.body; }
  var cssReady = new Promise(function (res) {
    if (!C.css) return res();
    var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = C.css; l.onload = l.onerror = function () { res(); };
    document.head.appendChild(l);
  });

  /* ---------- recently viewed ---------- */
  function recent() { var r = get(K_REC, []); return Array.isArray(r) ? r.filter(function (x) { return x && x.h && x.t && sameSite(x.u); }) : []; }
  if (C.p && C.p.h && !C.p.acc) {
    var r = recent().filter(function (x) { return x.h !== C.p.h; });
    r.unshift({ h: C.p.h, t: C.p.t, u: C.p.u, i: C.p.i, f: C.p.f, vr: C.p.vr, ts: Date.now() });
    set(K_REC, r.slice(0, MAX_REC));
  }
  function recentHTML(list, compact) {
    return '<div class="lgbx-rv__row">' + list.map(function (x) {
      return '<a class="lgbx-rv__card" href="' + esc(x.u) + '">' + (okImg(x.i) ? '<img src="' + esc(x.i) + '" alt="" width="150" height="150" loading="lazy">' : '<span class="lgbx-rv__ph"></span>') +
        '<span class="lgbx-rv__t">' + esc(x.t) + '</span>' + (x.f ? '<span class="lgbx-rv__p">' + (x.vr ? 'From ' : '') + esc(x.f) + '</span>' : '') + '</a>';
    }).join('') + '</div>';
  }
  function renderRecent(host, opts) {
    var list = recent().filter(function (x) { return !(C.p && x.h === C.p.h); }).slice(0, 6);
    if (!list.length) { if (host) host.hidden = true; return; }
    var box = host || document.createElement('section');
    box.className = 'lgbx-rv' + (opts && opts.inApp ? ' lgbx-rv--app' : ' page-width');
    box.setAttribute('aria-labelledby', 'lgbx-rv-h');
    box.hidden = false;
    box.innerHTML = '<div class="lgbx-rv__head"><h2 id="lgbx-rv-h">Recently viewed</h2><button type="button" class="lgbx-link" data-lgbx-rv-clear>Clear history</button></div>' +
      '<p class="lgbx-rv__note">Only on this device. These aren&rsquo;t saved to My Project &ndash; tap &ldquo;Save to My Project&rdquo; on a building to keep it.</p>' + recentHTML(list);
    if (!host) main().appendChild(box);
    return box;
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-lgbx-rv-clear]'); if (!b) return;
    del(K_REC); del('viewedProducts'); /* also the theme's own search history list */
    var s = b.closest('.lgbx-rv'); if (s) { s.innerHTML = '<p class="lgbx-rv__note" role="status">Recently viewed history cleared.</p>'; }
    track('recent_clear');
  });

  /* ---------- compare ---------- */
  function cmpList() { var c = get(K_CMP, []); return Array.isArray(c) ? c.filter(function (x) { return x && typeof x.h === 'string' && /^[a-z0-9-]+$/.test(x.h); }).slice(0, MAX_CMP) : []; }
  function inCmp(h) { return cmpList().some(function (x) { return x.h === h; }); }
  var tray, live;
  function say(m) { if (live) { live.textContent = ''; setTimeout(function () { live.textContent = m; }, 30); } }
  function toggleCmp(h, t, i) {
    var c = cmpList();
    if (inCmp(h)) { c = c.filter(function (x) { return x.h !== h; }); set(K_CMP, c); say(t + ' removed from compare'); }
    else {
      if (c.length >= MAX_CMP) { say('You can compare up to 4 buildings. Remove one first.'); paintTray(true); return; }
      c.push({ h: h, t: t, i: okImg(i) ? i : '' });
      if (!set(K_CMP, c)) { say('Sorry, this browser would not let us save your compare list.'); return; }
      say(t + ' added to compare. ' + c.length + ' of 4.'); track('compare_add');
    }
    paintAll();
  }
  function paintButtons() {
    document.querySelectorAll('[data-lgb-cmp]').forEach(function (b) {
      var on = inCmp(b.getAttribute('data-lgb-cmp')), want = on ? 'true' : 'false';
      if (b.getAttribute('aria-pressed') !== want) b.setAttribute('aria-pressed', want);
      var card = b.classList.contains('lgbx-cardcmp');
      var label = on ? (card ? 'Comparing' : 'Added to compare') : (card ? 'Compare' : 'Add to compare');
      var s = b.querySelector('span'); if (s && s.textContent !== label) s.textContent = label;
    });
  }
  function paintTray(full) {
    var c = cmpList();
    if (!tray) {
      tray = document.createElement('div'); tray.className = 'lgbx-tray'; tray.setAttribute('role', 'region'); tray.setAttribute('aria-label', 'Compare buildings');
      document.body.appendChild(tray);
      tray.addEventListener('click', function (e) {
        var x = e.target.closest('[data-lgbx-rm]'); if (x) { toggleCmp(x.getAttribute('data-lgbx-rm'), x.getAttribute('data-t') || 'Building'); return; }
        if (e.target.closest('[data-lgbx-open]')) openCompare();
        if (e.target.closest('[data-lgbx-clear]')) { set(K_CMP, []); say('Compare list cleared'); paintAll(); }
      });
    }
    document.body.classList.toggle('lgbx-has-tray', c.length > 0);
    if (!c.length) { tray.hidden = true; return; }
    tray.hidden = false;
    tray.innerHTML = '<div class="lgbx-tray__in"><ul class="lgbx-tray__items">' + c.map(function (x) {
      return '<li>' + (x.i ? '<img src="' + esc(x.i) + '" alt="" width="40" height="40">' : '') + '<span>' + esc(x.t) + '</span><button type="button" data-lgbx-rm="' + esc(x.h) + '" data-t="' + esc(x.t) + '" aria-label="Remove ' + esc(x.t) + ' from compare">&times;</button></li>';
    }).join('') + '</ul><div class="lgbx-tray__act">' +
      (full ? '<p class="lgbx-tray__msg">Up to 4 at a time &ndash; remove one to add another.</p>' : '') +
      '<button type="button" class="lgbx-btn" data-lgbx-open' + (c.length < 2 ? ' aria-describedby="lgbx-need2"' : '') + '>Compare (' + c.length + ')</button>' +
      '<button type="button" class="lgbx-link" data-lgbx-clear>Clear</button>' +
      (c.length < 2 ? '<span id="lgbx-need2" class="lgbx-tray__hint">Add one more to compare side by side</span>' : '') + '</div></div>';
  }
  function paintAll() { paintButtons(); paintTray(); paintAppCompare(); }

  function addCardButtons() {
    if (C.nocmp) return;
    document.querySelectorAll('product-card').forEach(function (card) {
      if (card.querySelector('.lgbx-cardcmp')) return;
      var a = card.querySelector('a[href*="/products/"]'); if (!a) return;
      var m = (a.getAttribute('href') || '').match(/\/products\/([a-z0-9-]+)/); if (!m) return;
      var title = a.getAttribute('aria-label') || txt(a.innerHTML) || 'Building';
      var img = card.getAttribute('data-featured-media-url') || '';
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'lgbx-cardcmp'; b.setAttribute('data-lgb-cmp', m[1]); b.setAttribute('data-t', title); b.setAttribute('data-i', img);
      b.setAttribute('aria-pressed', 'false'); b.setAttribute('aria-label', 'Compare ' + title);
      b.innerHTML = '<span>Compare</span>';
      card.appendChild(b);
    });
    paintButtons();
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-lgb-cmp]'); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var i = b.getAttribute('data-i') || (C.p && C.p.h === b.getAttribute('data-lgb-cmp') ? C.p.i : '');
    toggleCmp(b.getAttribute('data-lgb-cmp'), b.getAttribute('data-t') || 'Building', i);
  }, true);

  var cache = {};
  /* 21 Oct 2026: framing / floor / roof / treatment / cladding, copied word for word from each product's own
     specification into assets/lgb-specs.json (keyed by product handle). Loaded once, only when Compare opens. */
  var specs = null;
  function loadSpecs() {
    if (specs) return specs;
    var u = String(C.css || '').split('?')[0].replace(/lgb-cx\.css$/, 'lgb-specs.json');
    specs = (u ? fetch(u).then(function (r) { return r.ok ? r.json() : {}; }) : Promise.resolve({})).catch(function () { return {}; });
    return specs;
  }
  function fetchData(h) {
    if (cache[h]) return cache[h];
    cache[h] = fetch('/products/' + encodeURIComponent(h) + '?view=lgbcx' + previewQs(), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (t) { var d = JSON.parse(t.trim()); return loadSpecs().then(function (sp) { var x = sp && sp[h]; if (x) { d.fr = x.fr; d.fl = x.fl; d.rc = x.rc; d.tr = x.tr; d.cl = x.cl; } return d; }); })
      .catch(function () { delete cache[h]; return { h: h, err: true }; });
    return cache[h];
  }
  var dlg;
  var UNK = '<span class="lgbx-unk">Not listed &ndash; ask us</span>';
  function cell(v) { return v ? esc(v) : UNK; }
  /* Smallest and largest size by floor area, worked out from the size names themselves (e.g. "8ft x 6ft", "3.0m x 2.6m").
     If a name can't be read, we just say how many sizes there are - never a guessed measurement. */
  function sizeRange(sz) {
    if (!sz || !Array.isArray(sz.vals) || !sz.vals.length) return UNK;
    var n = sz.vals.length, best = null, worst = null;
    sz.vals.forEach(function (v) {
      var m = String(v).match(/([\d.]+)\s*(ft|m)\b[^x\d]*(?:([\d.]+)\s*in)?[^x]*x\s*([\d.]+)\s*(ft|m)\b/i); if (!m) return;
      var a = parseFloat(m[1]) * parseFloat(m[4]); if (!a) return;
      if (!best || a < best.a) best = { a: a, v: v };
      if (!worst || a > worst.a) worst = { a: a, v: v };
    });
    if (n === 1) return esc(sz.vals[0]);
    if (best && worst) return esc(best.v) + ' to ' + esc(worst.v) + '<br><small>' + n + ' sizes</small>';
    return n + ' sizes &ndash; see the building for the full list';
  }
  /* 21 Oct 2026 - "The differences in plain English". Only states facts that come straight from each
     building's own data (its lowest price, its listed wall/cladding, its delivery wording, the Display Site
     collection). It never calls anything "best" - it says which one is cheapest, thickest, and so on. */
  function pounds(s) { var n = parseFloat(String(s || '').replace(/[^0-9.]/g, '')); return isNaN(n) ? null : n; }
  function mm(s) { var m = String(s || '').match(/(\d+(?:\.\d+)?)\s*mm/i); return m ? parseFloat(m[1]) : null; }
  function summary(ok) {
    var out = [];
    var pr = ok.map(function (r) { return { r: r, p: pounds(r.from) }; }).filter(function (x) { return x.p; });
    if (pr.length === ok.length) {
      pr.sort(function (a, b) { return a.p - b.p; });
      if (pr[0].p < pr[1].p) out.push('<strong>' + esc(pr[0].r.t) + '</strong> has the lowest starting price (' + esc(pr[0].r.from) + ').');
    }
    var wt = ok.map(function (r) { return { r: r, w: mm(r.wt) }; }).filter(function (x) { return x.w; });
    if (wt.length === ok.length) {
      wt.sort(function (a, b) { return b.w - a.w; });
      if (wt[0].w > wt[1].w) out.push('<strong>' + esc(wt[0].r.t) + '</strong> has the thickest listed wall or cladding (' + esc(wt[0].r.wt) + ') &ndash; usually sturdier and better for a workshop or heavy storage.');
    }
    var inst = ok.filter(function (r) { return r.inc && /install/i.test(r.inc.dl || '') && /free|included/i.test(r.inc.dl || '') && !/via|approved installer|self/i.test(r.inc.dl || ''); });
    if (inst.length && inst.length < ok.length) out.push('Installation is included with ' + inst.map(function (r) { return '<strong>' + esc(r.t) + '</strong>'; }).join(' and ') + ' (the others are delivered for you or a recommended installer to put up).');
    var disp = ok.filter(function (r) { return r.disp; });
    if (disp.length && disp.length < ok.length) out.push('You can see ' + disp.map(function (r) { return '<strong>' + esc(r.t) + '</strong>'; }).join(' and ') + ' at our Display Site.');
    else if (disp.length && disp.length === ok.length) out.push('All of these are on display at our Display Site, so you can compare them side by side in person (the sizes on show may differ).');
    var brands = ok.map(function (r) { return r.b; }).filter(function (b, i, a) { return b && a.indexOf(b) === i; });
    if (brands.length > 1) out.push('These come from ' + brands.length + ' different manufacturers, so each has its own guarantee and delivery terms (shown below).');
    if (!out.length) return '';
    return '<div class="lgbx-sum"><h3>The differences in plain English</h3><ul>' + out.map(function (x) { return '<li>' + x + '</li>'; }).join('') + '</ul></div>';
  }
  function openCompare() {
    var c = cmpList(); if (!c.length) return;
    track('compare_open');
    if (!dlg) {
      dlg = document.createElement('dialog'); dlg.className = 'lgbx-dlg'; dlg.setAttribute('aria-labelledby', 'lgbx-dlg-h');
      document.body.appendChild(dlg);
      dlg.addEventListener('click', function (e) {
        if (e.target === dlg || e.target.closest('[data-lgbx-close]')) { dlg.close(); return; }
        var x = e.target.closest('[data-lgbx-rm2]'); if (x) { toggleCmp(x.getAttribute('data-lgbx-rm2'), x.getAttribute('data-t') || 'Building'); if (cmpList().length) openCompare(); else dlg.close(); }
      });
    }
    dlg.innerHTML = '<div class="lgbx-dlg__head"><h2 id="lgbx-dlg-h">Compare buildings</h2><button type="button" class="lgbx-x" data-lgbx-close aria-label="Close compare">&times;</button></div><div class="lgbx-dlg__body"><p class="lgbx-load" role="status">Loading&hellip;</p></div>';
    if (!dlg.open) { try { dlg.showModal(); } catch (e) { dlg.setAttribute('open', ''); } }
    Promise.all(c.map(function (x) { return fetchData(x.h); })).then(function (rows) {
      var ok = rows.filter(function (r) { return !r.err; });
      var rowsDef = [
        ['Brand', function (r) { return cell(r.b); }],
        ['Type', function (r) { return cell(r.ty); }],
        ['Price', function (r) { return '<strong>' + (r.varies ? 'From ' : '') + esc(r.from) + '</strong>' + (r.was ? ' <s>' + esc(r.was) + '</s>' : '') + (r.avail ? '' : '<br><small>Currently unavailable</small>'); }],
        ['Sizes', function (r) { return sizeRange(r.sz); }],
        ['Roof', function (r) { return cell(r.roof); }],
        ['Material', function (r) { return cell(r.mat); }],
        ['Wall / cladding', function (r) { return cell(r.wt); }],
        ['Cladding', function (r) { return cell(r.cl); }, 'cl'],
        ['Framing', function (r) { return cell(r.fr); }, 'fr'],
        ['Floor', function (r) { return cell(r.fl); }, 'fl'],
        ['Roof covering', function (r) { return cell(r.rc); }, 'rc'],
        ['Treatment', function (r) { return cell(r.tr); }, 'tr'],
        ['Delivery & installation', function (r) { return r.inc && r.inc.dl ? r.inc.dl + '.' : UNK; }],
        ['Base', function (r) { return r.inc && r.inc.base ? r.inc.base + '.' : UNK; }],
        ['Lead time', function (r) { return r.inc && r.inc.lead ? r.inc.lead + '.' : UNK; }],
        ['Guarantee', function (r) { return r.inc && r.inc.g ? r.inc.g : UNK; }],
        ['At our Display Site', function (r) { return r.disp ? 'Yes &ndash; one is on display (the size on show may differ). Ring to check before you come.' : 'Not on display at the moment &ndash; ask us about something similar.'; }]
      ];
      var head = '<tr><th scope="col" class="lgbx-lab"><span class="lgbx-sr">Detail</span></th>' + ok.map(function (r) {
        return '<th scope="col"><a href="' + esc(r.u) + '">' + (okImg(r.i) ? '<img src="' + esc(r.i) + '" alt="" width="160" height="160" loading="lazy">' : '') + '<span>' + esc(r.t) + '</span></a>' +
          '<button type="button" class="lgbx-link" data-lgbx-rm2="' + esc(r.h) + '" data-t="' + esc(r.t) + '">Remove</button></th>';
      }).join('') + '</tr>';
      /* spec rows only appear when at least one of the buildings lists that detail */
      rowsDef = rowsDef.filter(function (d) { return !d[2] || ok.some(function (r) { return r[d[2]]; }); });
      var body = rowsDef.map(function (d) { return '<tr><th scope="row" class="lgbx-lab">' + esc(d[0]) + '</th>' + ok.map(function (r) { return '<td>' + d[1](r) + '</td>'; }).join('') + '</tr>'; }).join('');
      var act = '<tr><th scope="row" class="lgbx-lab"><span class="lgbx-sr">Actions</span></th>' + ok.map(function (r) { return '<td><a class="lgbx-btn lgbx-btn--sm" href="' + esc(r.u) + '">View &amp; choose size</a></td>'; }).join('') + '</tr>';
      var failed = rows.length - ok.length;
      var sumHtml = ok.length >= 2 ? summary(ok) : '';
      dlg.querySelector('.lgbx-dlg__body').innerHTML =
        (ok.length < 2 ? '<p class="lgbx-note">Add another building to see them side by side. Tap &ldquo;Compare&rdquo; on any building.</p>' : '') +
         sumHtml + '<div class="lgbx-tbl-wrap" tabindex="0" role="region" aria-label="Comparison table, scroll sideways for more"><table class="lgbx-tbl"><thead>' + head + '</thead><tbody>' + body + act + '</tbody></table></div>' +
        (failed ? '<p class="lgbx-note">We couldn&rsquo;t load ' + failed + ' building' + (failed > 1 ? 's' : '') + '. Please try again.</p>' : '') +
        '<p class="lgbx-cta"><a class="lgbx-btn" href="' + WA + '?text=' + encodeURIComponent('Hi, could you price these for me: ' + ok.map(function (r) { return r.t; }).join(', ')) + '" target="_blank" rel="noopener">Get a price for these on WhatsApp</a> <a class="lgbx-btn lgbx-btn--sm" href="/pages/build-your-quote">Build a quote</a></p>' +
        '<p class="lgbx-note">&ldquo;From&rdquo; prices are the lowest price for the smallest or standard option. The price changes with the size and options you choose &ndash; see each building for the exact price. Delivery, installation and guarantees are each manufacturer&rsquo;s own terms. Not sure? <a href="' + WA + '" target="_blank" rel="noopener">WhatsApp us</a> or call 01543 398778.</p>';
    });
  }

  /* ---------- My LGB (only on /pages/my-lgb) ---------- */
  var appCmpHost;
  function paintAppCompare() {
    if (!appCmpHost) return;
    var c = cmpList();
    appCmpHost.hidden = !c.length;
    appCmpHost.innerHTML = '<div class="lgbx-card"><strong>Comparing (' + c.length + ' of 4)</strong><p class="lgbx-small">Buildings you&rsquo;ve picked to compare on this device.</p><ul class="lgbx-mini">' +
      c.map(function (x) { return '<li>' + esc(x.t) + '</li>'; }).join('') + '</ul><button type="button" class="lgbx-btn" data-lgbx-open-app>Open comparison</button></div>';
  }
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-lgbx-open-app]')) openCompare(); });

  var ACC = [
    ['gate', 'Narrowest gate or access width', 'text', 'e.g. 90cm, or no side access'],
    ['path', 'Narrow pathways', 'yn'], ['corners', 'Tight corners to get round', 'yn'], ['steps', 'Steps on the way', 'yn'],
    ['slope', 'Is the ground sloping?', 'yn'],
    ['base', 'Base', 'sel', ['', 'Not started', 'Planning one myself', 'Already have a base', 'Would like advice']],
    ['other', 'Anything else (parking, overhead cables, trees)', 'text', 'Optional']
  ];
  function ext() { var x = get(K_EXT, {}); if (!x || typeof x !== 'object') x = {}; x.access = x.access && typeof x.access === 'object' ? x.access : {}; return x; }
  function accessText(x) {
    x = x || ext(); var L = [];
    ACC.forEach(function (f) { var v = String(x.access[f[0]] || '').trim().slice(0, 300); if (v) L.push(f[1] + ': ' + v); });
    return L.join('\n');
  }
  function projectText() {
    var p = get(K_PRJ, {}); var x = ext(); var L = [];
    if (x.name) L.push('Project: ' + String(x.name).slice(0, 80));
    var items = p && Array.isArray(p.items) ? p.items.slice(0, 12) : [];
    if (items.length) { L.push('Buildings I like:'); items.forEach(function (it) { if (it && it.t) L.push('- ' + String(it.t).slice(0, 200) + (it.v ? ' (' + String(it.v).slice(0, 120) + ')' : '') + (sameSite(it.u) ? ' ' + location.origin + it.u : '')); }); }
    ['space', 'budget', 'postcode', 'notes'].forEach(function (k) { if (p && p[k]) L.push(k.charAt(0).toUpperCase() + k.slice(1) + ': ' + String(p[k]).slice(0, 600)); });
    var a = accessText(x); if (a) { L.push(''); L.push('Garden access & preparation:'); L.push(a); }
    return L.join('\n');
  }
  function initMyLgb() {
    var root = document.querySelector('.lgb-app'); if (!root) return;
    /* Help me choose: /pages/my-lgb?use=storage preselects the first question (links from the homepage/catalogue chips) */
    var mu = location.search.match(/[?&]use=([a-z]+)/);
    if (mu) { var ub = root.querySelector('[data-q="use"] button[data-v="' + mu[1] + '"]'); if (ub) { ub.click(); var ch = document.getElementById('lgb-app-choose'); if (ch) setTimeout(function () { ch.scrollIntoView({ block: 'start' }); }, 60); } }
    var proj = document.getElementById('lgb-app-project'); if (!proj) return;
    var x = ext();
    /* Project name */
    var saved = proj.querySelector('[data-lgb-saved]');
    var nameWrap = document.createElement('div'); nameWrap.className = 'lgbx-name';
    nameWrap.innerHTML = '<label>Name your project <span>(optional &ndash; e.g. &ldquo;Workshop at the bottom of the garden&rdquo;)</span><input type="text" maxlength="80" data-lgbx-name autocomplete="off"></label>' +
      '<p class="lgbx-shortcuts"><a href="#lgb-keep">Save as PDF, print or share</a> &middot; <a href="#lgb-cx-access">Garden access checker</a> &middot; <a href="/pages/display-site#lgbx-visit">Planning a visit?</a></p>';
    if (saved && saved.parentNode) saved.parentNode.insertBefore(nameWrap, saved);
    var nameIn = nameWrap.querySelector('input'); nameIn.value = x.name || '';
    nameIn.addEventListener('input', function () { var y = ext(); y.name = nameIn.value.slice(0, 80); set(K_EXT, y); sync(); });
    /* Compare + recently viewed inside My Project, clearly labelled */
    appCmpHost = document.createElement('div'); appCmpHost.className = 'lgbx-appcmp';
    var rvHost = document.createElement('section');
    if (saved && saved.parentNode) { var after = proj.querySelector('[data-lgb-empty]') || saved; after.parentNode.insertBefore(appCmpHost, after.nextSibling); appCmpHost.parentNode.insertBefore(rvHost, appCmpHost.nextSibling); }
    paintAppCompare(); renderRecent(rvHost, { inApp: true });
    /* Garden access & preparation checker */
    var card = document.createElement('div'); card.className = 'lgbx-card lgbx-acc'; card.id = 'lgb-cx-access';
    card.innerHTML = '<strong>Garden access &amp; preparation</strong><p class="lgbx-small">Getting a building into the garden is the bit people forget. Tell us now and we&rsquo;ll check it fits through before you order. Suitability always has to be confirmed for the building and manufacturer you choose.</p>' +
      '<div class="lgbx-acc__grid">' + ACC.map(function (f) {
        var id = 'lgbx-acc-' + f[0], inp;
        if (f[2] === 'yn') inp = '<select id="' + id + '" data-lgbx-acc="' + f[0] + '"><option value="">Choose&hellip;</option><option>No</option><option>Yes</option><option>Not sure</option></select>';
        else if (f[2] === 'sel') inp = '<select id="' + id + '" data-lgbx-acc="' + f[0] + '">' + f[3].map(function (o) { return '<option value="' + esc(o) + '">' + (o ? esc(o) : 'Choose&hellip;') + '</option>'; }).join('') + '</select>';
        else inp = '<input id="' + id + '" type="text" maxlength="300" placeholder="' + esc(f[3]) + '" data-lgbx-acc="' + f[0] + '">';
        return '<div class="lgbx-acc__f' + (f[0] === 'other' ? ' lgbx-acc__f--wide' : '') + '"><label for="' + id + '">' + esc(f[1]) + '</label>' + inp + '</div>';
      }).join('') + '</div>' +
      '<p class="lgbx-small">Photos help: send pictures of your gate, path and the spot on <a href="' + WA + '?text=' + encodeURIComponent('Hi Craig, here are photos of my garden access for my project') + '" target="_blank" rel="noopener">WhatsApp</a>. <a href="/pages/choosing-a-base">Base guide</a> &middot; <a href="/pages/delivery-installation">Delivery &amp; installation</a></p>';
    var keep = document.getElementById('lgb-keep'), send = proj.querySelector('.lgb-app-send');
    var anchor = (keep && keep.parentNode === (send && send.parentNode) ? keep : send);
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(card, anchor); else proj.appendChild(card);
    card.querySelectorAll('[data-lgbx-acc]').forEach(function (el) { el.value = x.access[el.getAttribute('data-lgbx-acc')] || ''; });
    card.addEventListener('input', onAcc); card.addEventListener('change', onAcc);
    function onAcc(e) { var el = e.target; if (!el.hasAttribute || !el.hasAttribute('data-lgbx-acc')) return; var y = ext(); y.access[el.getAttribute('data-lgbx-acc')] = el.value.slice(0, 300); set(K_EXT, y); sync(); }
    /* Make sure the enquiry carries the name + access details (hidden fields, so nothing the customer typed is overwritten) */
    var form = document.getElementById('lgb-app-quote-form'), hName, hAcc, note;
    if (form) {
      hName = document.createElement('input'); hName.type = 'hidden'; hName.name = 'contact[Project name]';
      hAcc = document.createElement('input'); hAcc.type = 'hidden'; hAcc.name = 'contact[Garden access & preparation]';
      form.appendChild(hName); form.appendChild(hAcc);
      var ta = form.querySelector('[data-lgb-body]');
      note = document.createElement('p'); note.className = 'lgbx-small lgbx-also'; note.hidden = true;
      if (ta && ta.parentNode) ta.parentNode.parentNode.insertBefore(note, ta.parentNode.nextSibling);
    }
    function sync() {
      var y = ext(), a = accessText(y);
      if (hName) hName.value = y.name || '';
      if (hAcc) hAcc.value = a;
      if (note) { var bits = []; if (y.name) bits.push('your project name'); if (a) bits.push('your garden access details'); note.hidden = !bits.length; note.textContent = 'We’ll also receive ' + bits.join(' and ') + ' from above.'; }
    }
    sync();
    /* WhatsApp: add the name + access details to the message at the moment it is opened */
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-lgb-wa-project]'); if (!a) return;
      var y = ext(), extra = accessText(y), m = a.href.match(/[?&]text=([^&]*)/), t = '';
      try { t = m ? decodeURIComponent(m[1].replace(/\+/g, ' ')) : ''; } catch (err) { t = ''; }
      t = t.split('\n\nGarden access & preparation:')[0];
      if (y.name && t.indexOf('Project: ') === -1) t = t.replace(/^(.*?:)\n/, '$1\nProject: ' + y.name + '\n');
      if (extra) t += '\n\nGarden access & preparation:\n' + extra;
      if (t.length > 1900) t = t.slice(0, 1890) + '…';
      a.href = WA + '?text=' + encodeURIComponent(t);
    }, true);
  }

  /* ---------- Display Site page: send the project before a visit ---------- */
  function initVisit() {
    var b = document.querySelector('[data-lgbx-visit-share]'); if (!b) return;
    var t = projectText(), empty = document.querySelector('[data-lgbx-visit-empty]');
    if (!t) { b.hidden = true; if (empty) empty.hidden = false; return; }
    b.href = WA + '?text=' + encodeURIComponent(('Hi Craig, I’m planning a visit to the Display Site. Here’s my project from My LGB:\n\n' + t).slice(0, 1900));
  }

  /* ---------- start ---------- */
  function start() {
    cssReady.then(function () {
      addCardButtons();
      if ('MutationObserver' in window) {
        var grid = document.querySelector('main'); var tmo;
        if (grid) new MutationObserver(function () { clearTimeout(tmo); tmo = setTimeout(addCardButtons, 120); }).observe(grid, { childList: true, subtree: true });
      }
      live = document.createElement('p'); live.className = 'lgbx-sr'; live.setAttribute('role', 'status'); live.setAttribute('aria-live', 'polite'); document.body.appendChild(live);
      if (C.ph === 'my-lgb') initMyLgb();
      else if ((C.pt === 'product' && C.p && !C.p.acc) || C.pt === 'collection' || C.pt === 'index' || C.pt === 'search') renderRecent();
      if (C.ph === 'display-site') initVisit();
      paintAll();
    });
    window.addEventListener('storage', function (e) { if (e.key === K_CMP) paintAll(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
